import React, { useState } from 'react';
import UserInfoForm from './UserInfo';
// import BillForm from './Bill';
import DeepgramForm from './Deepgram';
// import PaymentForm from './Payment';
import OrderReview from './OrderReview';
import BillingSummary from './Summary';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Grid, Paper } from '@mui/material';

const theme = createTheme();

export default function Order() {
  const [state, setState] = useState({
    userInfo: {
      firstName: '',
      lastName: '',
      company: '',
      email: '',
      streetAddress: '',
      state: '',
      city: '',
      zip: '',
      country: '',
      // checkBill: true,
    },
    // billInfo: {
    //   address: '',
    //   state: '',
    //   city: '',
    //   zip: '',
    //   country: '',
    // },
    deepgramInfo: {
      channels: 5,
      cost: 50,
      applicationID: [
        {
          key: 0,
          id: '',
        },
      ],
    },
    // paymentInfo: {
    //   select: 'credit',
    //   firstName: '',
    //   lastName: '',
    //   cardNumber: '',
    //   expireDate: null,
    //   cvv: '',
    // },
  });

  const [error, setError] = useState({
    userInfo: {
      firstName: false,
      lastName: false,
      company: false,
      email: false,
      streetAddress: false,
      state: false,
      city: false,
      zip: false,
      country: false,
    },
    // billInfo: {
    //   address: false,
    //   state: false,
    //   city: false,
    //   zip: false,
    //   country: false,
    // },
    // paymentInfo: {
    //   firstName: false,
    //   lastName: false,
    //   cardNumber: false,
    //   cvv: false,
    //   expireDate: false,
    // },
  });
  const handleChange = (name, value, formInfo) => {
    switch (formInfo) {
      case 1:
        setState({
          ...state,
          userInfo: {
            ...state.userInfo,
            [name]: value,
          },
        });
        break;
      // case 2:
      //   setState({
      //     ...state,
      //     billInfo: {
      //       ...state.billInfo,
      //       [name]: value,
      //     },
      //   });
      //   break;
      case 3:
        if (name === 'channels')
          if (value !== 1000)
            setState({
              ...state,
              deepgramInfo: {
                ...state.deepgramInfo,
                [name]: value,
                cost: (value - 5) * 3 + 50,
              },
            });
          else
            setState({
              ...state,
              deepgramInfo: {
                ...state.deepgramInfo,
                [name]: value,
                cost: 600,
              },
            });
        else
          setState({
            ...state,
            deepgramInfo: {
              ...state.deepgramInfo,
              [name]: value,
            },
          });
        break;
      // case 4:
      //   setState({
      //     ...state,
      //     paymentInfo: {
      //       ...state.paymentInfo,
      //       [name]: value,
      //     },
      //   });
      //   break;
      // case 5:
      //   setState({
      //     ...state,
      //     [name]: value,
      //   });
      // break;
      default:
        break;
    }
    handleError(name, value, formInfo);
  };

  const handleError = (name, value, formInfo) => {
    switch (formInfo) {
      case 1:
        if (name === 'email')
          setError({
            ...error,
            userInfo: {
              ...error.userInfo,
              [name]: !(
                value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
              ),
            },
          });
        else if (name !== 'checkBill')
          setError({
            ...error,
            userInfo: {
              ...error.userInfo,
              [name]: value ? false : true,
            },
          });
        break;
      // case 2:
      //   setError({
      //     ...error,
      //     billInfo: {
      //       ...error.billInfo,
      //       [name]: value ? false : true,
      //     },
      //   });
      //   break;
      // case 4:
      //   if (name === 'cardNumber')
      //     setError({
      //       ...error,
      //       paymentInfo: {
      //         ...error.paymentInfo,
      //         [name]: value.indexOf('-') > 0 ? true : false,
      //       },
      //     });
      //   else
      //     setError({
      //       ...error,
      //       paymentInfo: {
      //         ...error.paymentInfo,
      //         [name]: value ? false : true,
      //       },
      //     });
      //   break;
      default:
        break;
    }
  };

  const onClickPay = (validationData) => {
    setError({
      ...validationData,
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid
        container
        spacing={4}
        sx={{ my: 20, px: { xs: 4, sm: 12, md: 18, lg: 24, xl: 37.56 } }}
      >
        <Grid item xs={12} md={8}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Paper elevation={3} sx={{ p: 4 }}>
                <UserInfoForm
                  state={state.userInfo}
                  onChange={handleChange}
                  error={error.userInfo}
                  onError={handleError}
                />
              </Paper>
            </Grid>
            {/* {false ? (
              <Grid item xs={12}>
                <Paper elevation={3} sx={{ p: 4 }}>
                  <BillForm
                    state={state.billInfo}
                    onChange={handleChange}
                    error={error.billInfo}
                    onError={handleError}
                  />
                </Paper>
              </Grid>
            ) : null} */}
            <Grid item xs={12}>
              <Paper elevation={3} sx={{ p: 4 }}>
                <DeepgramForm
                  state={state.deepgramInfo}
                  onChange={handleChange}
                  error={error.DeepgramForm}
                  onError={handleError}
                />
              </Paper>
            </Grid>
            {/* <Grid item xs={12}>
              <Paper elevation={3} sx={{ p: 4 }}>
                <PaymentForm
                  state={state.paymentInfo}
                  onChange={handleChange}
                  error={error.paymentInfo}
                  onError={handleError}
                />
              </Paper>
            </Grid> */}
          </Grid>
        </Grid>
        <Grid item xs={12} md={4}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Paper elevation={3} sx={{ p: 4 }}>
                <OrderReview
                  itemCount={state.deepgramInfo.applicationID}
                  channelCount={state.deepgramInfo.channels}
                />
              </Paper>
            </Grid>
            {/* <Grid item xs={12}>
              <Paper elevation={3} sx={{ p: 4 }}>
                <TaxForm state={state.taxRate} onChange={handleChange} />
              </Paper>
            </Grid> */}
            <Grid item xs={12}>
              <Paper elevation={3} sx={{ p: 4 }}>
                <BillingSummary
                  itemCount={state.deepgramInfo.applicationID}
                  channelCount={state.deepgramInfo.channels}
                  info={state}
                  error={error}
                  onError={onClickPay}
                />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
